export const removeTrailingSlash = (str?: string) => (str ? str.replace(/\/$/, '') : '');
export const removeLeadingSlash = (str?: string) => (str ? str.replace(/^\//, '') : '');
export const removeEnclosingSlashes = (str?: string) => (str ? str.replace(/^\/|\/$/g, '') : '');
export const normalizePath = (path?: string) => `${removeEnclosingSlashes(path ?? '').replace(/[^a-z0-9-_/?]/gi, '')}`;
export const normalizePathForPage = (path?: string) => `/${normalizePath(path)}`;

/**
 * Decodes common HTML entities to their character equivalents.
 * Useful for content from WordPress that may have double-encoded entities.
 */
export const decodeHtmlEntities = (str?: string): string => {
    if (!str) return '';
    return str
        .replaceAll('&amp;', '&')
        .replaceAll('&lt;', '<')
        .replaceAll('&gt;', '>')
        .replaceAll('&quot;', '"')
        .replaceAll('&#39;', "'")
        .replaceAll('&#x27;', "'");
};
